import moment from "moment";
import React, { useCallback, useMemo, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { getFieldName, getFieldValue } from "../../scripts/helperScripts";
import {
  getFormsySubmissionsByFormIdForClient,
  getFormsySubmissionsByIds,
} from "../services/soar";

function FormResults({
  contactID,
  clientProgram,
  formName,
  formNumber,
  formVersionId,
  formVersionNumber,
  formId,
  formPath,
  extraFields,
  status,
  tab,
}) {
  const location = useLocation();
  const [expanded, setExpanded] = useState(false);
  const [formSubmissions, setFormSubmissions] = useState([]);
  const [loaded, setLoaded] = useState(false);

  const handleExpandStatusChange = useCallback(
    (value) => {
      const controller = new AbortController();
      setExpanded(value);

      if (value) {
        const loadSubmissions = async () => {
          const signal = controller.signal;
          let response;

          if (formId !== undefined)
            response = await getFormsySubmissionsByFormIdForClient(
              formId,
              contactID,
              signal
            );
          else
            response = await getFormsySubmissionsByIds(
              formVersionId,
              contactID.toString().replace(/[{}]/g, ""),
              signal
            );

          if (!signal.aborted) {
            if (response) {
              const result = JSON.parse(response);
              console.log(`${formName}: `, result);
              if (
                result &&
                result.FormSubmissions &&
                result.FormSubmissions.Submission
              ) {
                const sorted = result.FormSubmissions.Submission.filter(
                  (submission) =>
                    `{${submission.ClientProgramId}}` ===
                      clientProgram.ccx_client_programid ||
                    submission.ClientProgramId === ""
                ).sort((a, b) => {
                  const aDate = new Date(a.CreatedOn);
                  const bDate = new Date(b.CreatedOn);
                  if (aDate < bDate) return 1;
                  if (aDate > bDate) return -1;
                  else return 0;
                });
                setFormSubmissions(sorted);
                console.log("Form Submissions:", sorted);
              }
            }

            setLoaded(true);
          }
        };

        loadSubmissions();
      }

      return () => {
        controller.abort();
      };
    },
    [contactID, formName, formVersionId, formId, clientProgram]
  );

  const getFormSubmissionsMarkup = () => {
    if (formSubmissions.length > 0) {
      const activeSubmissions = formSubmissions.filter(
        (sub) => sub.Active === "1"
      );

      if (activeSubmissions.length > 0) {
        return activeSubmissions.map((t) => (
          <React.Fragment key={t.SubmissionId}>
            <div className="text-white bg-safy3-1 p-2 m-2">
              <div className="row">
                <div className="col">
                  {moment.utc(t.CreatedOn).local().format("L LT")}
                </div>
                <div className="col">{t.CreatedByName}</div>
                <div className="col">
                  <div className="clearfix">
                    <div className="float-start">
                      {t.FinalSigned === "0" ? "Not Final Signed" : "Signed"}
                    </div>
                    <div className="float-end px-1">
                      <Link
                        title={`View ${formName}`}
                        className="fas fa-pen text-white"
                        to={`/${formPath}${
                          formPath !== "form" &&
                          t.VersionIntId !== undefined &&
                          t.VersionIntId !== "1"
                            ? `v${t.VersionIntId}`
                            : ""
                        }/${t.FormVersionId}/${t.ContactId}/${t.SubmissionId}`}
                        state={{
                          tab: tab,
                          previousPath: location.pathname,
                          selectedProgram: clientProgram,
                        }}
                        target="_blank"
                      />
                    </div>
                  </div>
                </div>
              </div>
              {extraFields
                ?.filter((field) =>
                  getFieldValue(t.FormResults.results[field.name])
                )
                .map((field) => (
                  <div className="row" key={field}>
                    <div className="col">
                      {field.displayText}:{" "}
                      {field.isDate
                        ? moment(
                            getFieldValue(t.FormResults.results[field.name])
                          ).format("L")
                        : field.optionSet?.find(
                            (option) =>
                              option._id ===
                              getFieldValue(t.FormResults.results[field.name])
                          )?.name ||
                          getFieldValue(t.FormResults.results[field.name])}
                    </div>
                  </div>
                ))}
            </div>
          </React.Fragment>
        ));
      } else return <div>No {formName} for client</div>;
    } else if (loaded === true) {
      return <div>No {formName} for client</div>;
    } else {
      return <div>Loading</div>;
    }
  };

  const hifiWraparound = useMemo(() => {
    return (
      getFieldName(clientProgram["unit.ccx_program"]) ===
      "High Fidelity Wraparound"
    );
  }, [clientProgram]);

  return (
    <>
      <div className="border p-2 mb-4 card-safy">
        <div className="h6">
          <i
            className={
              expanded
                ? "fas fa-chevron-up p-1 text-primary"
                : "fas fa-chevron-down p-1 text-primary"
            }
            onClick={() => handleExpandStatusChange(!expanded)}
          ></i>
          {formName}
          {(formName === "GAD-7" ||
            formName === "PHQ-9" ||
            formName === "CATS") &&
          hifiWraparound
            ? " (CT use only)"
            : ""}
          {formNumber && (
            <>
              <br />
              <span className="ms-4" style={{ fontSize: "14px" }}>
                {formNumber}
              </span>
            </>
          )}
          {status === "Active" && (
            <Link
              title={`Add ${formName}`}
              className="fas fa-plus-circle float-end p-1 text-primary"
              to={`/${formPath}${
                formPath !== "form" &&
                formVersionNumber !== undefined &&
                formVersionNumber !== "1"
                  ? `v${formVersionNumber}`
                  : ""
              }/${formVersionId}/${contactID.toString().replace(/[{}]/g, "")}`}
              state={{
                selectedProgram: clientProgram,
              }}
            />
          )}
        </div>
        {expanded ? getFormSubmissionsMarkup() : null}
      </div>
    </>
  );
}

export default FormResults;
